import {Pipe, PipeTransform} from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({name: 'cost'})
export class CostPipe extends CurrencyPipe implements PipeTransform {

    transform(value: any, currencyCode?: any, format?: any): any {
        if (currencyCode && currencyCode === 'UAH') {
            currencyCode = '₴';
        }
        return super.transform(value, currencyCode, undefined, format);
    }
}
